(() => {
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  function initialize() {
    document.querySelectorAll('.mobile-menu:not([data-enhanced])').forEach(menu => {
      menu.dataset.enhanced = 'true';
      const trigger = menu.querySelector('summary');
      const nav = menu.querySelector('nav');
      const dialog = document.createElement('dialog');
      dialog.className = 'navigation-panel';
      dialog.id = 'Navigation-' + Math.random().toString(36).slice(2);
      dialog.setAttribute('aria-label', nav.getAttribute('aria-label'));
      const heading = document.createElement('div');
      heading.className = 'navigation-heading';
      const label = document.createElement('span');
      label.textContent = menu.querySelector('.menu-label')?.textContent || nav.getAttribute('aria-label');
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'navigation-close';
      close.setAttribute('aria-label', trigger.dataset.closeLabel || trigger.getAttribute('aria-label'));
      close.innerHTML = '<span></span><span></span>';
      heading.append(label, close);
      dialog.append(heading, nav.cloneNode(true));
      document.body.append(dialog);
      trigger.setAttribute('aria-controls', dialog.id);
      trigger.setAttribute('aria-expanded', 'false');
      let closing = false;
      function shut() {
        if (closing || !dialog.open) return;
        closing = true;
        dialog.classList.add('is-closing');
        trigger.setAttribute('aria-expanded', 'false');
        setTimeout(() => {
          dialog.close();
          dialog.classList.remove('is-closing');
          closing = false;
        }, reduced() ? 0 : 280);
      }
      trigger.addEventListener('click', event => {
        event.preventDefault();
        if (dialog.open) { shut(); return; }
        dialog.showModal();
        document.body.classList.add('navigation-is-open');
        trigger.setAttribute('aria-expanded', 'true');
        requestAnimationFrame(() => close.focus({preventScroll:true}));
      });
      close.addEventListener('click', shut);
      dialog.addEventListener('cancel', event => { event.preventDefault(); shut(); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right) shut();
      });
      dialog.addEventListener('close', () => {
        document.body.classList.remove('navigation-is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({preventScroll:true});
      });
      dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', shut));
    });
  }
  initialize();
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.mobile-menu summary[aria-controls]').forEach(trigger => {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (panel?.open) panel.close();
      panel?.remove();
    });
  });
  document.addEventListener('shopify:section:load', initialize);
})();
